import React from "react";

import Cta from "../cta/cta";
import SingleImage from "./hero.image.v1";
import ImageSliderV2 from "./hero.imageslider.v2";
import VideoComponent from "src/@components/video";

import { getLanguageField } from "src/utils/language";

import SearchWidgetFullControl from "src/components/searchWidgetSection/searchWidgetFullControl/search.widget";
import BackgroundImageWrapper from "src/components/backgroundImageWrapper/backgroundImageWrapper";
import { CTAButtonV2 } from "src/components/ctabutton";
import ImageV3 from "src/components/image/image.v3";
import { ModuleWrapperV2 } from "src/components/moduleWrapper/moduleWrapper.v2";
import SearchWidgetSection from "src/components/searchWidgetSection";
import SiteContainer from "src/components/siteContainer";

import "./hero.css";

function has_text(str) {
    if (!str) return false;
    if (typeof str !== "string") return false;
    return str.length > 0;
}

const Hero = (props) => {
    const { data } = props;

    // fix preview
    if (data?.item?.background_images && data?.item?.background_images.length >= 1) {
        // fix undefined pictures
        data.item.background_images = data?.item?.background_images.filter(image => image.directus_files_id !== null);
        data.item.background_images = data.item.background_images.map(image => image.directus_files_id ? image : {...image, directus_files_id: { filename_disk: image.image.imageFile }});
    }


    const renderFeatures = () => {
        const { features } = data?.item;
        if(!features || !features.length) return null;

        return <div className="flex gap-6 py-6 flex-wrap flex-col sm:flex-row justify-center gap-y-4">
            {features.map((f, index) => {
                const { icon, translations } = f.hero_feature_id;
                const title = getLanguageField(translations, data.selectedLanguage, "title");
                return <div key={`feat-${index}`} className="flex gap-2 text-2xl leading-[1.25] items-center">
                    { icon && icon.imageFile ? <ImageV3 image={icon} className="w-6 h-6"/> : null }
                    { title ? title : null}
                </div>
            })}
        </div>
    }

    const renderImageComponent = (images) => {
        if (!images || !images.length) return null;
        return images.length === 1
            ? <SingleImage moduleData={moduleData} overlayColorWithTransparency={overlayColorWithTransparency} image={images[0]}/>
            : <ImageSliderV2 overlayColorWithTransparency={overlayColorWithTransparency} moduleData={moduleData} images={images}/>
    }

    const renderTypeImage = (images, mobileImages) => {
        if (moduleData.type !== "image") return null;
        if (!images.length) return null;
        const hasMobileImages = mobileImages?.length;
        const desktopWrapper = hasMobileImages ? "hidden sm:block" : "block";
        const mobileWrapper = "block sm:hidden";
        const desktopComponent = renderImageComponent(images);
        const mobileComponent = renderImageComponent(mobileImages);

        return (
            <>
                <div className={`${desktopWrapper}`}>
                    {desktopComponent}
                </div>
                {
                    hasMobileImages
                    ? <div className={`${mobileWrapper}`}>
                        {mobileComponent}
                    </div>
                    : null
                }
            </>
        )
    }

    const moduleData = {
        title: getLanguageField(data?.item?.translations, data?.selectedLanguage, "title"),
        subtitle: getLanguageField(data?.item?.translations,data?.selectedLanguage,"subtitle"),
        anchor: getLanguageField(data?.item?.translations,data?.selectedLanguage,"anchor"),
        type: data?.item?.type,
        alignment: data?.item?.alignment,
        height: data?.item?.height,
        textShadow: data?.item?.text_shadow,
        backgroundImages: data?.item?.background_images,
        mobileBackgroundImages: data?.item?.mobile_background_images,
        backgroundImagePosition: data?.item?.background_image_position || "center",
        backgroundColor: data?.item?.background_color?.value,
        boxedBackgroundColor: data?.item?.width !== "full_screen" ? data?.item?.boxed_background_color?.value : null,
        textColor: data?.item?.text_color?.value,
        overlay: data?.item?.overlay,
        overlayColor: data?.item?.overlay_color?.value,
        overlayOpacity: data?.item?.overlay_opacity,
        bookingWidget: data?.item?.booking_widget,
        name: data?.item?.name,
        width: data?.item?.width,
        roundedCorners: data?.item?.rounded_corners,
        arrow: data.item?.arrow_color?.value,
        arrowBubble: data.item?.arrow_bubble_color?.value,
        selectedBubbleIndicator: data.item?.selected_bubble_indicator_color?.value,
        unSelectedBubbleIndicator: data.item?.unselected_bubble_indicator_color?.value,
        videoSource: data.item?.video?.source,
        videoUrl: data.item?.video?.url,
        videoFile: data.item?.video?.file?.imageFile,
        videoPlaceholderImage: ImageV3.getImageUrl(data.item?.video?.placeholder_image?.imageFile || ""),
      };

      const getBgColorHeroLayer = () => {
        if (!moduleData.bookingWidget) return "";
        if (moduleData.width === "boxed") return moduleData.boxedBackgroundColor;
        else return moduleData.backgroundColor;
    }

      const overlayColorWithTransparency = moduleData.overlay ? moduleData.overlayColor + Math.floor( moduleData.overlayOpacity / 100 * 255 || 0 * 255).toString(16) : null
      var shadow = moduleData.textShadow ? { textShadow: "0px 4px 4px rgba(0, 0, 0, 0.15)" } : null;

      let alignment = "items-center";
      let xalignment = "justify-center";
      let textalignment = "text-center";
      if (moduleData.alignment === 'left') { alignment = "items-start"; textalignment="text-left"; xalignment="justify-start"; }
      if (moduleData.alignment === 'right') { alignment = "items-end"; textalignment="text-right"; xalignment="justify-end"; }

      let rounding = "";
      if (moduleData.roundedCorners && moduleData.width !== 'full_screen') rounding = "rounded-xl";

      const textWidth = moduleData.width !== 'full_screen' ? 'max-w-5xl' : 'max-w-7xl';

      let heightClass = 'big-size';
      if (moduleData.height === '50vh') heightClass = 'small-size'
      if (moduleData.height === '75vh') heightClass = 'medium-size'

      let widthClass = 'w-full';
      if (moduleData.width !== 'full_screen') widthClass = 'w-contained';

      let bookingClass = 'without-booking';
      if (moduleData.bookingWidget) bookingClass = 'with-booking';

      const hasPrimaryCTA = data.item?.primary_cta;
      const hasSecondaryCTA = data.item?.secondary_cta;
      const hasSoftCTA = data.item?.soft_cta;
      const hasButtons = hasPrimaryCTA || hasSecondaryCTA || hasSoftCTA;

      const isImageSlider = moduleData.type === 'image' && moduleData.backgroundImages.length > 1;
      let paddingHoriz = isImageSlider && moduleData.width !== 'full_screen' ? 'px-12' : 'px-4 sm:px-6 lg:px-8';
      const containterClassname = moduleData.width === 'full_screen' ? "" : "p-4 sm:p-6 xl:px-0 max-w-none"
        const wrapperClassname = moduleData.width === 'full_screen' ? "" : "max-w-7xl mx-auto w-full";

        const booking_widget = data.item.booking_search_widget
            ? <SearchWidgetFullControl defaultLanguage={data?.defaultLanguage} selectedLanguage={data.selectedLanguage} item={data.item.booking_search_widget} />
            : <SearchWidgetSection selectedLanguage={data.selectedLanguage} defaultLanguage={data?.defaultLanguage}/>

      if (moduleData.type === "split_image") return <div>
        {/* wrapper to add padding bottom when booking widget */}
        <div className={`hero ${bookingClass}`}>
            {/* cta module -> in directus is filtered to only choose cta split iamge */}
            <Cta data={{ item: data.item.split_image, selectedLanguage:data.selectedLanguage, isHero: true }} defaultLanguage={data?.defaultLanguage} />
        </div>
        {/* booking widget */}
        {
            moduleData.bookingWidget ? (
                <div className="px-0 sm:px-6 bg-transparent">
                    {booking_widget}
                </div>
            ) : null
        }
    </div>

      return (
        <BackgroundImageWrapper backgroundColor={moduleData.backgroundColor}>
            <SiteContainer fullwidth={moduleData.width === 'full_screen'} className={`${containterClassname}`}>
            <ModuleWrapperV2 isFullWidth={moduleData.width === 'full_screen'} name={moduleData.name} className={`${wrapperClassname}`} anchor={moduleData.anchor} backgroundColor={moduleData.boxedBackgroundColor} roundedCorners={moduleData.roundedCorners}>
                <div
                    className={`hero w-full flex flex-col relative z-0 overflow-hidden ${heightClass} ${widthClass} ${bookingClass} ${rounding}`} style={{background: getBgColorHeroLayer()}}>

                    <div className={`${textWidth} m-auto pointer-events-none w-full mx-auto overflow-hidden`} style={{ color: moduleData.textColor }}>
                        <div className={`w-full h-full flex flex-col justify-start ${alignment} gap-4 ${paddingHoriz}`}>
                            {has_text(moduleData.title) ? <h1 className={`${textalignment} headline1 mt-8`} style={{ ...shadow }}>{moduleData.title}</h1> : null}
                            {has_text(moduleData.subtitle) ? <h2 className={`${textalignment} headerText`} style={{ ...shadow }}>{moduleData.subtitle}</h2> : null}
                            {renderFeatures()}
                            {hasButtons ? <>
                                <div className={`flex flex-col sm:flex-row w-full ${xalignment} gap-4 my-4`}>
                                    {hasPrimaryCTA ? <CTAButtonV2
                                        language={data.selectedLanguage}
                                        defaultLanguage={data.defaultLanguage}
                                        ctabutton={data.item.primary_cta} /> : null}
                                    {hasSecondaryCTA ? <CTAButtonV2
                                        language={data.selectedLanguage}
                                        defaultLanguage={data.defaultLanguage}
                                        ctabutton={data.item.secondary_cta} /> : null}
                                    {hasSoftCTA ? <CTAButtonV2
                                        language={data.selectedLanguage}
                                        defaultLanguage={data.defaultLanguage}
                                        ctabutton={data.item.soft_cta} /> : null}
                                </div>
                            </> : null}
                        </div>
                    </div>

                    {
                        moduleData.type === 'video' && (moduleData.videoUrl || moduleData.videoFile) ? // If type is video, we want to show a hero video with a placeholder image if the video doesn't load
                            <div className={`hero-layer absolute top-0 left-0 bottom-0 right-0 -z-10 inset-0 ${rounding}`} style={{ '--video-overlay-color': overlayColorWithTransparency }}>
                                <VideoComponent
                                    source={moduleData.videoSource}
                                    url={moduleData.videoUrl || moduleData.videoFile}
                                    autoPlay loop removeControls asBackground
                                    placeholder={moduleData.videoPlaceholderImage}
                                    className={`hero-layer w-full h-full object-cover ${rounding}`}
                                    videoClassname={`hero-layer w-full h-full object-cover ${rounding}`}
                                />
                            </div>
                        :
                            null
                    }

                    {
                        renderTypeImage(moduleData.backgroundImages, moduleData.mobileBackgroundImages)
                    }
                </div>
                {
                    moduleData.bookingWidget ? (
                        <div className="px-0 sm:px-6 bg-transparent">
                            {booking_widget}
                        </div>
                    ) : null
                }

            </ModuleWrapperV2>
            </SiteContainer>
        </BackgroundImageWrapper>
      )
}



export default Hero;